/**
 * Mandatory profile fields for customers before using the rest of the app.
 * Used by route guard and profile form validation.
 */
export function isMandatoryProfileComplete(user) {
  if (!user || typeof user !== 'object') return false;
  const firstName = String(user.firstName ?? '').trim();
  const lastName = String(user.lastName ?? '').trim();
  const email = String(user.email ?? '').trim();
  const phone = String(user.phone ?? '').trim();
  if (!firstName || !lastName || !email || !phone || phone.length < 7) return false;
  const dob = user.dob;
  if (dob == null || dob === '') return false;
  const d = new Date(dob);
  return !Number.isNaN(d.getTime());
}

/** Gate applies to shoppers only; staff can use admin routes without full profile. */
export function isMandatoryProfileGateRole(user) {
  const role = user?.role;
  return role === 'user' || role == null || role === '';
}

export function mustCompleteProfileBeforeBrowsing(loggedIn, user) {
  if (!loggedIn || !user) return false;
  if (!isMandatoryProfileGateRole(user)) return false;
  if (user.loading) return false;
  const hasIdentity = Boolean(user.userId || user._id);
  if (!hasIdentity) return false;
  return !isMandatoryProfileComplete(user);
}
